import { LaunchDarklyServiceModule } from 'services/access/launchDarkly/launchDarkly.service';
import { OnboardingServiceModule } from 'services/data/onboarding.service';
import { TrialServiceModule, NOT_TRIAL } from 'components/trial/trial.service';

export const FounderGuideServiceModule = angular
    .module('app.services.founderGuide', [
        OnboardingServiceModule,
        LaunchDarklyServiceModule,
        TrialServiceModule
    ])
    .factory('founderGuideService', (
        onboardingService,
        launchDarklyService,
        trialService,
        $timeout,
        $q,
        $window
    ) => {
        const EMPTYSTATE = {
            tasks: { completed: {} }
        };

        let steps = [
            {
                id: 'landing',
                icon: 'home',
                name: 'Starting Point',
                color: '#261d4c',
                completeTask: 'path.task'
            },
            {
                id: 'product',
                icon: 'local_offer',
                name: 'Products',
                color: '#0ebbd2',
                completeTask: 'organize.addProduct'
            },
            {
                id: 'personalize',
                icon: 'edit',
                name: 'Personalize',
                color: '#849ca7',
                completeTask: 'design.styleTheme,organize.addMenu,design.addLogo,design.editTheme'
            },
            {
                id: 'page',
                icon: 'insert_drive_file',
                name: 'Pages',
                color: '#cb63a2',
                completeTask: 'organize.addPage'
            },
            {
                id: 'finalstep',
                icon: 'star',
                name: 'Final Step',
                color: '#808080',
                completeTask: '',
                locked: true
            }
        ];

        let paths = {
            PRODUCT: 'Product',
            IDEA: 'Idea',
            CLUELESS: 'Clueless',
            NOPATH: 'No Path'
        };

        function getNextUnfinishedStep(state) {
            updateStepsComplete(state);
            let nextIncomplete = steps.map(step => step.complete).indexOf(false);
            if (nextIncomplete === -1) return steps.length;
            return nextIncomplete + 1;
        }

        function updateStepsComplete(state) {
            const FIRST_STEP = 0;
            const FINAL_STEP = 4;

            steps.forEach((step) => {
                step.complete = step.completeTask.split(',').some(task => state.tasks.completed[task]);
            });

            steps[FIRST_STEP].complete = true; // first step is always complete

            steps[FINAL_STEP].locked = !steps
                .filter(step => step.id !== 'finalstep')
                .every(step => step.complete);

            steps[FINAL_STEP].complete = false; // final step is never "complete"
        }

        function getCompletedStepCount() {
            return steps.reduce((acc, step) => {
                return acc + (step.complete ? 1 : 0);
            }, 0);
        }

        function setActiveStep(activeStep) {
            steps.forEach((step, index) => {
                step.active = activeStep === index + 1;
            });
        }

        function getFounderGuideNextStepNotice(state) {
            let nextUnfinishedStep = getNextUnfinishedStep(state);
            return steps[nextUnfinishedStep - 1].id;
        }

        function getCompleteTasksForStep(stepId) {
            let editStep = steps.filter(step => step.id === stepId);
            if (editStep.length) {
                return editStep[0].completeTask.split(',');
            }

            return [];
        }

        function isTaskComplete(stepId, state = EMPTYSTATE) {
            const tasks = getCompleteTasksForStep(stepId);
            return tasks.some(task => state.tasks.completed[task]);
        }

        function getStateDelayed() {
            // the delay allows other tasks to finish updating the state before we request it
            return $timeout(() => {
                return onboardingService.getState();
            });
        }

        function completeFounderGuideTask(taskId, taskKey, milestone) {
            const milestones = [null, 'Product Added', 'Store Edited', 'Page Generated'];
            return $q.all([
                onboardingService.getState(),
                launchDarklyService.getFeature('founder-guide'),
                trialService.getTrialStatus()
            ]).then(([state, feature, trialStatus]) => {
                if (!state.tasks.completed[taskId]) {
                    if (taskKey) onboardingService.completeInitialTask(taskId, taskKey);
                    else onboardingService.completeTask(taskId);

                    if (feature) {
                        ($window.dataLayer || []).push({
                            event: 'milestone_complete',
                            action: `Milestone ${milestone}`,
                            value: milestones[milestone]
                        });
                    }

                    return trialStatus !== NOT_TRIAL;
                }

                return false;
            });
        }

        return {
            paths,
            steps,
            completeFounderGuideTask,
            getCompletedStepCount,
            getCompleteTasksForStep,
            getFounderGuideNextStepNotice,
            getStateDelayed,
            getNextUnfinishedStep,
            isTaskComplete,
            updateStepsComplete,
            setActiveStep
        };
    }).name;


// WEBPACK FOOTER //
// ./src/app/services/utilities/founderGuide.service.js